import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/partner/products2/partners-credentialsSubProviders/filter'; // Importing Filter component
import Table from 'views/partner/products2/partners-credentialsSubProviders/table'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * PartnersSubProvidersView class extends JetView to create a specific view for partner sub-providers.
 */
export default class PartnersSubProvidersView extends JetView {
    /**
     * Configures the UI components for the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            rows: [Filter, Table], // Layout containing Filter and Table components
        };
        webix.ui.fullScreen(); // Set the UI to full screen mode

        // Check permissions for adding partner products
        if (!devConfig.getPermAction('partnerProducts2SCredentialsSubProviders', 'Add')) {
            this.show('./partner.products2.partnersProviders'); // Redirect if no permission
        } else {
            return {
                id: 'a5', // Unique identifier for the view
                type: 'clean', // Clean type for the view
                view: 'form', // Form view type
                scroll: 'y', // Enable vertical scrolling
                rows: [
                    {
                        responsive: 'a5', // Responsive layout
                        type: 'wide', // Wide type for the column
                        cols: [left], // Columns containing the left layout
                    },
                ],
            };
        }
    }

    /**
     * Initializes the view. Currently empty.
     */
    init() {}
}

// FILE DOCUMENTED
